import { chars } from './chars-bitmaps';

export class ScrollingTextFrames {

    constructor(text, loopCount, duration, textColor, backColor) {
        this.charObjects = chars;
        this.text = text;
        this.textColor = textColor;
        this.backColor = backColor;
        this.loopCount = loopCount;
        this.duration = duration;
        this.on = '255,255,255';
        this.off = '0,0,0';
        this.width = 8;
        this.height = 8;
        this.matrix = this.imagiMatrix(this.height,this.width);
        this.animation = {
                frames : [],
                loop_count : this.loopCount,
                scrolling_text : {
                    text: this.text,
                    text_color : this.textColor,
                    back_color : this.backColor,
                    duration : this.duration,
                    loop_count : this.loopCount
                }
        }

        if(textColor === 'on') {
            this.textColor = this.on;
        }

        if(textColor === 'off') {
            this.textColor = this.off;
        }

        if(backColor === 'on') {
            this.backColor = this.on;
        }

        if(backColor === 'off') {
            this.backColor = this.off;
        }
    }

    init() {
        
        let bitmappedWord = this.stringToMatrix(this.text);
        
        for ( let i=0; i + 8 <= bitmappedWord[0].length; i++) {
            
            let frame = [];
            bitmappedWord.forEach(row => {
                frame.push(row.slice(i,i+8));
            })

            this.addFrame(this.bitmapToMatrix(frame, this.textColor, this.backColor), this.duration)
        }
        return this.animation;

    }

    addFrame(matrix, duration=100) {

        let frameObject = {
            frame : this.matrixToColorString(matrix),
            duration : duration,
        }

        this.animation.frames.push(frameObject)

    }

    matrixToColorString(matrix) {

        let colorString = '';

        for (let row=0; row<this.height; row++){
            for(let col=0; col<this.width; col++){
                let str = matrix[row][col].toString();
                if (str === '0'){
                    colorString += '0';
                } else {
                    colorString += str;
                    colorString += ';';
                }
            }
        }

        return colorString.slice(0,-1);

    }

    imagiMatrix(height, width) {

        let matrix = [];

        for (let i=0; i<height; i++){
            let row = [];
            for(let j=0; j<width; j++){
                row.push(0);
            }
            matrix.push(row);
        }

        return matrix;

    }

    bitmapToMatrix(bitmap, textColor, backColor) {
        
        let matrix = this.imagiMatrix(this.height, this.width)

        for (let row=0; row<this.height; row++){
            for(let col=0; col<this.width; col++){
                if (bitmap[row][col] === 1){
                    matrix[row][col] = textColor;
                } else {
                    matrix[row][col] = backColor;
                }
            }
        }

        return matrix;

    }

    stringToMatrix(text) {

        let spacing = this.charObjects[' '].split(',').map(Number);
        let result = [];

        while(spacing.length) {
            
            result.push(spacing.splice(0,8))
        }

        text = text.split('');

        
        for (let letter of text) {

            if (letter in this.charObjects){

                let newLetter = this.charObjects[letter].split(',').map(Number);

                let bitmapLetter = [];

                    while(newLetter.length) {

                        bitmapLetter.push(newLetter.splice(0,8))

                    }
                
                result = this.addMatrices(result, bitmapLetter)

            }
        }

        result = this.addMatrices(result, this.imagiMatrix(8,5), 0)

        return result;
    }

    addMatrices(matrix1, matrix2, overlap=2) {

        let matrix3 = [];

            matrix1.forEach((row, index) => {

                if (overlap > 0 ){

                let smallerRow = row.splice(0,row.length - overlap)
                let newRow = smallerRow.concat(matrix2[index])
                matrix3.push(newRow)

                } else {

                    let newRow = row.concat(matrix2[index])
                    matrix3.push(newRow)

                }
            })

            return matrix3;
    }

}